export const COMPANY_EMAIL = 'support@bitnite.studio';
